module.exports = __webpack_public_path__ + "static/avatar-48137669465fa0d91d82c7ae6b0aea33.jpg";